export default "__VITE_ASSET__BaWFcETK__"